import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9;
import { spacing } from "../../util/spacing";
import mediaQueries from "../../util/mediaqueries";
import styled, { css } from 'styled-components';
import Grid from "../grid-container/next";
import Headline from "../typography/headline/next";
import Text from "../typography/text/next";
import ModuleContainer from "../module-container";
import { Container as ActionBar } from "../action-bar";
export var Section = styled(ModuleContainer).withConfig({
  componentId: "sc-rfbche-0"
})(["padding:", ";", " ", " ", ""], spacing(8, 0), mediaQueries.sm(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: ", ";\n  "])), 0)), spacing(9, 0)), mediaQueries.md(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    padding: ", ";\n  "])), 0)), spacing(10, 0)), mediaQueries.xl(_t3 || (_t3 = _(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding: ", ";\n  "])), 0)), spacing(12, 0)));
export var HeadingsContainer = styled(Grid).withConfig({
  componentId: "sc-rfbche-1"
})(["text-align:center;margin-bottom:", ";row-gap:", ";", ""], spacing(10), spacing(2), mediaQueries.lg(_t4 || (_t4 = _(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    row-gap: ", ";\n  "])), 0)), spacing(3)));
var baseHeadingsStyles = css(["grid-column:1 / -1;", " ", ""], mediaQueries.md(_t5 || (_t5 = _(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    grid-column: 3 / -3;\n  "]))))), mediaQueries.lg(_t6 || (_t6 = _(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    grid-column: 4 / -4;\n  "]))))));
export var Heading = styled(Headline).withConfig({
  componentId: "sc-rfbche-2"
})(["", ""], baseHeadingsStyles);
export var Subheading = styled(Text).withConfig({
  componentId: "sc-rfbche-3"
})(["", ""], baseHeadingsStyles);
export var CardsContainer = styled(Grid).withConfig({
  componentId: "sc-rfbche-4"
})(["row-gap:", ";", ""], spacing(7), mediaQueries.md(_t7 || (_t7 = _(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    row-gap: ", ";\n  "])), 0)), spacing(8)));
export var CardContainer = styled.div.withConfig({
  componentId: "sc-rfbche-5"
})(["grid-column:1 / -1;", ""], mediaQueries.md(_t8 || (_t8 = _(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    grid-column: ", ";\n  "])), 0)), function (_ref) {
  var index = _ref.index,
    cardsLength = _ref.cardsLength;
  switch (cardsLength) {
    case 1:
      return '5 / span 4';
    case 2:
      return index === 0 ? '3 / span 4' : 'span 4';
    default:
      return 'span 4';
  }
}));
export var ActionBarContainer = styled(Grid).withConfig({
  componentId: "sc-rfbche-6"
})(["margin-top:", ";", "{grid-column:1 / -1;}", ""], spacing(10), ActionBar, mediaQueries.sm(_t9 || (_t9 = _(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    justify-items: center;\n  "]))))));